import { Component } from 'preact'
import cx from 'classnames'

import UploadBar from '../upload/bar'
import DeleteButton from '../deleteButton/deleteButton'
import BurosferaVacancyFormImageUploaderPlaceholder from './burosferaVacancyFormImageUploaderPlaceholder'

import { isValidImageUpload, readAsDataURL } from 'uploadUtils'
import uploadVacancyFormImage from './uploadImage'

export default class BurosferaVacancyFormImageUploader extends Component {
  constructor(props) {
    super(props)

    this.state = { imageUrl: props.imageUrl }

    this.onFileInputChange = this.onFileInputChange.bind(this)
    this.onUploadProgress = this.onUploadProgress.bind(this)
    this.onUploadCompleted = this.onUploadCompleted.bind(this)
    this.onUploadError = this.onUploadError.bind(this)
    this.onUploadDelete = this.onUploadDelete.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.onDragStart = () => this.setState({ isDragOver: true })
    this.onDragEnd = () => this.setState({ isDragOver: false })
  }

  componentDidMount() {
    document.addEventListener('documentDrop', this.onDrop)
    document.addEventListener('documentDragStart', this.onDragStart)
    document.addEventListener('documentDragEnd', this.onDragEnd)
  }

  componentWillUnmount() {
    document.removeEventListener('documentDrop', this.onDrop)
    document.removeEventListener('documentDragStart', this.onDragStart)
    document.removeEventListener('documentDragEnd', this.onDragEnd)
  }

  componentWillReceiveProps({ imageUrl }) {
    if (!imageUrl) this.setState({ imageUrl })
  }

  onDrop({ detail: { files } }) {
    this.upload(files)
  }

  onFileInputChange() {
    if (!this.fileInput?.files?.length) return

    this.upload(this.fileInput.files)
  }

  onUploadProgress(loaded) {
    this.setState({ uploadingFileLoaded: loaded })
  }

  upload(files) {
    if (!isValidImageUpload(files)) return

    const image = files[0]

    this.uploadImage(image)
      .then(this.onUploadCompleted)
      .then(() => this.displayFile(image))
      .catch(this.onUploadError)
      .then(() => this.setState({ isUploading: false }))
  }

  uploadImage(file) {
    this.setState({
      isUploading: true,
      uploadingFileName: file.name,
      uploadingFileTotal: file.size,
    })

    return uploadVacancyFormImage({ file, onProgress: this.onUploadProgress })
  }

  displayFile(image) {
    readAsDataURL(image)
      .then(imageUrl => this.setState({ imageUrl }))
  }

  onUploadCompleted(json) {
    const { onLoaded } = this.props
    const { id: imageId, url: imageUrl } = json

    if (onLoaded) onLoaded({ imageId, imageUrl })
  }

  onUploadError(e) {
    console.error('Vacancy image failed to upload', e) // FIXME
  }

  onUploadDelete() {
    const { onDeleted } = this.props
    const imageUrl = null

    this.setState({ imageUrl }, () => onDeleted && onDeleted())
  }

  render() {
    const { imageUrl } = this.state

    const className = cx(
      'burosferaVacancyForm-imageUploader',
      { is__dragOver: this.state.isDragOver, is__loaded: !!this.state.imageUrl }
    )

    return (
      <div className={ className }>
        <BurosferaVacancyFormImageUploaderPlaceholder
          fileInputRef={ el => this.fileInput = el }
          onChange={ this.onFileInputChange } />

        <UploadBar file={ this.state.uploadingFileName }
            loaded={ this.state.uploadingFileLoaded }
            total={ this.state.uploadingFileTotal }
            isActive={ this.state.isUploading } />

        { imageUrl &&
          <div className="burosferaVacancyForm-imageUploaderResult"
            style={ `background-image: url(${imageUrl})` }>

            <DeleteButton onClick={ this.onUploadDelete }/>
          </div>
        }
      </div>
    )
  }
}
